export default __webpack_public_path__ + "static/media/hero-home@2x.2a6bf856.png";